import type { GalleryModalButtonProps } from "./gallery-modal-button.type";

import { Button } from "antd";
import classNames from "classnames";

export const GalleryModalButton = ({
  outlined,
  onClick,
  className,
  ...props
}: GalleryModalButtonProps) => {
  return (
    <Button
      color="default"
      variant="text"
      shape="circle"
      size="large"
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      className={classNames("gallery-modal-button", className, {
        "-outlined": outlined,
      })}
      {...props}
    />
  );
};
